/**
 * @file
 * Global VUE Components
 * Used in library: vue
 *
 * Use this file to register components globally
 * This configuration will be set in @/bootstrap/app.ts
 */

import {ComponentOptions} from 'simpli-web-sdk'

import Multiselect from 'vue-multiselect/src/Multiselect.vue'
import ItDisplay from '@/components/itrack/ItDisplay.vue'
import ItTable from '@/components/itrack/ItTable.vue'
import ItAudit from '@/components/itrack/ItAudit.vue'
import ItRender from '@/components/itrack/ItRender.vue'
import ItMap from '@/components/itrack/ItMap.vue'
import ItMemberSelect from '@/components/itrack/ItMemberSelect.vue'
import ItSearch from '@/components/itrack/ItSearch.vue'
import ItUpload from '@/components/itrack/ItUpload.vue'
import ItNfCsvUpload from '@/components/itrack/ItNfCsvUpload.vue'
import ItDriverAssociationCsvUpload from '@/components/itrack/ItDriverAssociationCsvUpload.vue'
import ItThumb from '@/components/itrack/ItThumb.vue'
import ItEnderecoFormSection from '@/components/itrack/ItEnderecoFormSection.vue'

/**
 * Global VUE Components
 */
export const components: ComponentOptions = {
  Multiselect,
  ItDisplay,
  ItTable,
  ItAudit,
  ItRender,
  ItMap,
  ItMemberSelect,
  ItSearch,
  ItUpload,
  ItNfCsvUpload,
  ItDriverAssociationCsvUpload,
  ItThumb,
  ItEnderecoFormSection,
}
